<div class="print-history-popup" style="background-image: none; box-shadow: none" *ngIf="askSendSMS">
  <div class="t-popup-close"></div>

  <div class="t-popup-frame">
    <div class="t-popup-body">
      <button
        class="t-btn-popup-close"
        aria-label="close popup"
        [disabled]="creatingPending"
        (click)="askSendSMS = false; error = ''"
      ></button>

      <h2 style="color: #d7a95b">
        {{ "GUI.Links.ask send sms" | translate }}
      </h2>

      <div
        class="l-flex l-flex-w t-fieldmargin patient-details"
        style="align-items: center; display: flex; justify-content: center"
      >
        <mat-spinner
          *ngIf="creatingPending"
          diameter="18"
          strokeWidth="3"
          class="spinner-white"
          style="margin-right: 0.75rem"
        >
        </mat-spinner>

        <div *ngIf="sent && !creatingPending" style="font-weight: 600">
          {{ "GUI.Links.Sent" | translate }}
        </div>

        <div *ngIf="error && !creatingPending" style="color: #d9534f; font-weight: 600">
          {{ error }}
        </div>
      </div>

      <div
        class="l-flex l-flex-w t-fieldmargin patient-details"
        style="gap: 0.75rem; display: flex; justify-content: space-evenly"
      >
        <button
          class="search-btn"
          style="width: 6em"
          [disabled]="creatingPending || sent"
          (click)="sendSMS(appointmentAutoIndex, patientPID, true)"
        >
          {{ "GUI.Links.Send" | translate }}
        </button>

        <button
          class="search-btn"
          style="width: 6em; background: #888"
          [disabled]="creatingPending"
          (click)="askSendSMS = false"
        >
          {{ "appointments.gui.buttons.No" | translate | titlecase }}
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showErrorModal" class="print-history-popup">
  <div class="print-history-popup-body">
    <h2 class="popup-title" style="text-align: center; color: #dcb16b" *ngIf="!appointmentsByRooms">
      {{ "appointments.gui.labels.Please Select a Doctor" | translate | titlecase }}
    </h2>
    <h2 class="popup-title" style="text-align: center; color: #dcb16b" *ngIf="appointmentsByRooms">
      {{ "appointments.gui.labels.please Select A Room" | translate }}
    </h2>
    <button
      (click)="showErrorModal = false"
      class="print-history-popup-close"
      aria-label="close popup"
    ></button>
  </div>
</div>

<div *ngIf="showExamErrorModal" class="print-history-popup">
  <div class="print-history-popup-body">
    <h2 class="popup-title" style="text-align: center; color: #dcb16b" *ngIf="!appointmentsByRooms">
      The exam <b>{{ examErrorName }}</b> is not performed by this doctor.
      <br />
      Please select a different doctor.
    </h2>

    <h2 class="popup-title" style="text-align: center; color: #dcb16b" *ngIf="appointmentsByRooms">
      The exam <b>{{ examErrorName }}</b> cannot be performed in this room.
      <br />
      Please select a different room.
    </h2>

    <button
      (click)="showExamErrorModal = false"
      class="print-history-popup-close"
      aria-label="close popup"
    ></button>
  </div>
</div>

<div *ngIf="showSelection" class="print-history-popup" cdkDrag cdkDragBoundary=".t-popup">
  <div class="print-history-popup-body">
    <button
      (click)="showSelection = false; showAlert = false"
      class="print-history-popup-close"
      aria-label="close popup"
    ></button>
    <div>
      <h2 style="text-align: center; cursor: grab" cdkDragHandle>
        {{ "appointments.gui.labels.Manage Time Slot" | translate | titlecase }}
        <br />
        <div
          style="
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            color: #e6c794;
            gap: 2px;
          "
        >
          <span style="cursor: pointer" matTooltip="Go forward 5 minutes" (click)="fiveMinutes(true)">
            +
          </span>
          <span>{{ selectedDateInfo.start | date : "HH:mm" }}</span>
          <span style="cursor: pointer" matTooltip="Go back 5 minutes" (click)="fiveMinutes(false)">
            -
          </span>
        </div>
      </h2>
    </div>
    <div
      style="
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 1em;
        padding: 5% 0;
      "
    >
      <button
        class="search-btn"
        style="width: 40%"
        (click)="handelAddAppointment()"
        [matTooltip]="'appointments.gui.tooltips.Add A New Appointment' | translate | titlecase"
      >
        {{ "appointments.gui.buttons.Add New Appointment" | translate | titlecase }}
      </button>
      <button
        *ngIf="!this.patientsService.currentPatient"
        class="search-btn search-btn--newPatient"
        style="width: 40%"
        [matTooltip]="'appointments.gui.tooltips.Add A New Block' | translate | titlecase"
        (click)="handelBlock()"
      >
        {{ "appointments.gui.buttons.Add Block" | translate | titlecase }}
      </button>
    </div>
    <div *ngIf="showAlert" class="t-validation-wrap">
      <button class="t-menu-item is-invalid-left"></button>
      <div class="t-validation-message-left" style="width: 20em; top: -5em; font-size: medium">
        <span style="border-radius: 8px">
          <p style="margin-bottom: 1em">
            {{ "appointments.gui.customTooltips.notDuringActivityHours" | translate }}
          </p>
          <div
            style="display: flex; justify-content: space-between; margin-left: 1vw; margin-right: 1vw"
          >
            <button class="t-menu-item" (click)="addAppointment(); showAlert = false">
              {{ "appointments.gui.buttons.Yes" | translate | titlecase }}
            </button>
            <button class="t-menu-item" (click)="showSelection = false; showAlert = false">
              {{ "appointments.gui.buttons.No" | translate | titlecase }}
            </button>
          </div>
        </span>
      </div>
    </div>
  </div>
</div>
<aside class="l-sidebar l-flex l-column" style="height: 100%">
  <img class="off-mobile sidebar-logo logo-3d-effect" src="../../assets/icons/logo.svg" alt="Artisan Sonics" />
  <div class="userPanel"></div>
  <app-bar (pageChange)="setPage($event, true,undefined,undefined,true)" [switchpage]="showPage$"></app-bar>
  <nav class="mainNav l-fg1 scroller" style="align-content: end">
    <app-legend *ngIf="showCalendar && page == 'Calendar'" [legendData]="examsLegend"></app-legend>
  </nav>
  <app-docpanel></app-docpanel>
</aside>
<!-- ========================== header (start) ========================== -->
<header class="l-header" style="padding: 0; height: auto">
  <div class="on-mobile header-logo">
    <img src="assets/icons/logo.svg" alt="Artisan Sonics" />
  </div>
  <div
    class="l-header-panel"
    [ngStyle]="
      !showPat && !showPatDetails && !showAppointment
        ? { 'justify-content': 'space-between' }
        : { 'justify-content': 'flex-end' }
    "
    style="display: flex; flex-direction: row"
  >
    <!-- ================ Default Selection (Start) ================-->
    <ng-container *ngIf="!isMultiSelect">
      <!-- ======== Doctor Selection (Start) ========-->
      <div
        *ngIf="
          ls.clinicUsers &&
          !showPat &&
          !showPatDetails &&
          !showAppointment &&
          page != 'List' &&
          !appointmentsByRooms
        "
        style="right: 10em"
      >
        <div class="l-flex l-flex-c t-field t-field-pad">
          <label [matTooltip]="'appointments.gui.tooltips.Doctor\'s Name' | translate | titlecase">
            <img src="../../assets/icons/drb.svg" />
          </label>

          <i class="t-sep"></i>

          <span class="t-validation-wrap l-fg1">
            <select
              [(ngModel)]="ls.doctor"
              class="t-select w100"
              (ngModelChange)="
                refetchEvents(this.startDateDisplayWithGap, this.endDateDisplayWithGap, $event);
                refetchActivityHours();
                handleViewChange()
              "
              style="text-align: center"
            >
              <option [ngValue]="null" *ngIf="ls.clinicUsers.length > 1">
                {{ "appointments.gui.selects.All" | translate }}
              </option>
              <ng-container *ngFor="let e of getDoctors()">
                <option [value]="e.UID">{{ e.Name }}</option>
              </ng-container>
            </select>
          </span>
        </div>
      </div>
      <!-- ======== Doctor Selection (End) ========-->

      <!-- ======== Room Selection (Start) ========-->
      <div
        *ngIf="!showPat && !showPatDetails && !showAppointment && page != 'List' && appointmentsByRooms"
        style="right: 10em"
      >
        <div class="l-flex l-flex-c t-field t-field-pad">
          <label matTooltip="שם החדר">
            <img src="../../assets/icons/room-blue.svg" />
          </label>

          <i class="t-sep"></i>

          <span class="t-validation-wrap l-fg1">
            <select
              [(ngModel)]="ls.room"
              class="t-select w100"
              style="text-align: center"
              (ngModelChange)="
                refetchEvents(this.startDateDisplayWithGap, this.endDateDisplayWithGap, $event);
                refetchRoomsActivityHours();
                handleViewChange()
              "
            >
              <option [ngValue]="null">All</option>
              <!-- <option  [ngValue]="'No Room'">No Room</option> -->
              <ng-container *ngFor="let r of ls.activeRooms">
                <option [value]="r.AutoIndex">{{ ls.roomLabel(r) }}</option>
              </ng-container>
            </select>
          </span>
        </div>
      </div>
      <!-- ======== Room Selection (End) ========-->
    </ng-container>
    <!-- ================ Default Selection (End) ================-->

    <!-- ================ Multi Selection (Start) ================-->
    <ng-container *ngIf="isMultiSelect">
      <!-- ======== Doctor Selection (Start) ========-->
      <div
        *ngIf="
          ls.clinicUsers &&
          !showPat &&
          !showPatDetails &&
          !showAppointment &&
          page != 'List' &&
          !appointmentsByRooms
        "
        style="right: 10em"
      >
        <div class="l-flex l-flex-c t-field t-field-pad" style="height: 3em">
          <label [matTooltip]="'appointments.gui.tooltips.Doctor\'s Name' | translate | titlecase">
            <img src="../../assets/icons/drb.svg" />
          </label>

          <i class="t-sep"></i>

          <span class="t-validation-wrap l-fg1">
              <mat-form-field floatLabel="auto" class="transparent-field">
              <mat-label>
                {{ "appointments.gui.labels.Doctors" | translate }}
              </mat-label>
              <mat-select
                [(value)]="selectedDoctors"
                (selectionChange)="onDoctorsChange($event); refetchRoomsActivityHours()"
                multiple
              >
                <ng-container *ngFor="let doctor of ls.clinicUsers">
                  <mat-option [value]="doctor.UID">
                    {{ doctor.Name }}
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </span>
        </div>
      </div>
      <!-- ======== Doctor Selection (End) ========-->

      <!-- ======== Room Selection (Start) ========-->
      <div
        *ngIf="!showPat && !showPatDetails && !showAppointment && page !== 'List' && appointmentsByRooms"
      >
        <div class="l-flex l-flex-c t-field t-field-pad" style="height: 3em">
          <label matTooltip="שם החדר">
            <img src="../../assets/icons/room-blue.svg" />
          </label>

          <i class="t-sep"></i>
          <span class="t-validation-wrap l-fg1">
            <mat-form-field floatLabel="auto" class="transparent-field">
              <mat-label>
                {{ "appointments.gui.label.rooms" | translate }}
              </mat-label>
              <mat-select
                [(value)]="selectedRooms"
                (selectionChange)="onRoomsChange($event); refetchRoomsActivityHours()"
                multiple
              >
                <ng-container *ngFor="let room of ls.activeRooms">
                  <mat-option [value]="room.AutoIndex">
                    {{ ls.roomLabel(room) }}
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </span>
        </div>
      </div>
      <!-- ======== Room Selection (End) ========-->
    </ng-container>
    <!-- ================ Multi Selection (End) ================-->

    <div style="display: flex; height: 3em; align-items: center; z-index: 21">
      <div style="display: flex; align-items: center; margin: 0 0.5em">
        <div
          style="display: flex; padding-right: 0; max-height: 2.5em; max-width: 16em"
          class="t-field"
          *ngIf="ls.isObgyn && showCalendar && page == 'Calendar'"
        >
          <label style="width: 50%; align-content: center; white-space: nowrap; margin-right: 0.5em">
            {{ "appointments.gui.labels.add lmp" | translate | titlecase }}
          </label>
          <input
            [matDatepicker]="LMPDate"
            [(ngModel)]="lmpDate"
            [max]="maxLMP"
            [min]="minLMP"
            type="text"
            class="t-field-text w100"
          />
          <img
            src="../../assets/icons/date.svg"
            (click)="LMPDate.open()"
            style="margin-left: 0.5em; margin-right: 0.5em"
          />
          <mat-datepicker #LMPDate startView="year"></mat-datepicker>
        </div>
        <div style="gap: 0.8em; display: flex; align-items: center; margin-left: 1em">
          <img
            *ngIf="ls.isObgyn && showCalendar && page == 'Calendar' && lmpDate"
            (click)="lmpDate = null; calculatePregnancyAge()"
            style="cursor: pointer"
            src="../../assets/icons/x-orange.svg"
          />
          <button
            *ngIf="ls.isObgyn && showCalendar && page == 'Calendar' && lmpDate"
            (click)="calculatePregnancyAge()"
            class="calc-btn"
          >
          {{ "appointments.gui.buttons.calculate" | translate }}
          </button>
        </div>
      </div>

      <h3
        *ngIf="patientsService.currentPatient && showCalendar && page == 'Calendar'"
        style="color: #fff; white-space: nowrap; display: flex; align-items: center; gap: 0.5em"
      >
        {{ "appointments.gui.labels.Schedule an Appointment For" | translate | titlecase }}
        {{ patientsService.currentPatient.First }}
        {{ patientsService.currentPatient.Last }}
        <span *ngIf="selectedExamName"> ({{ selectedExamName }}) </span>
        <img
          (click)="patientsService.resetPat(); lmpDate = null"
          style="cursor: pointer"
          src="../../assets/icons/x-orange.svg"
        />
      </h3>
    </div>
    <div
      style="
        display: flex;
        flex-direction: row;
        width: fit-content;
        align-items: center;
        justify-content: space-between;
        gap: 1em;
        margin-left: 2em;
      "
    >
      <button
        *ngIf="page == 'Calendar' && appointmentsByRooms"
        (click)="showSearch = true"
        class="orange-btn"
      >
        {{ "appointments.gui.buttons.search" | translate }}
      </button>
      <img
        *ngIf="ls.premissions && ls.premissions.uploadDocuments && patientsService.currentPatient"
        style="cursor: pointer"
        matTooltip="{{ 'GUI.documents.tooltips.Attach Document' | translate }}"
        height="46em"
        width="46em"
        (click)="openDocumentsAdd = true"
        src="../../assets/icons/fileupload.svg"
      />
      <img
        *ngIf="patientsService.currentPatient && ls.clinicalAccess"
        style="cursor: pointer"
        [matTooltip]="'appointments.gui.tooltips.Patient Medical History' | translate | titlecase"
        (click)="redirectAdministrationPatient()"
        height="41em"
        width="41em"
        src="../../assets/icons/medical-white.svg"
      />
      <img
        *ngIf="ls.premissions?.Appointments && patientsService.currentPatient"
        style="cursor: pointer"
        [matTooltip]="'appointments.gui.tooltips.Patient Billing' | translate | titlecase"
        (click)="goBillingsPatient(patientsService.currentPatient)"
        height="41em"
        width="41em"
        src="../../assets/icons/billings-white.svg"
      />
      <img
        style="cursor: pointer; margin: 0 5% 0 0"
        [matTooltip]="'appointments.gui.tooltips.Print Day Appointments' | translate | titlecase"
        height="41em"
        width="41em"
        *ngIf="showPrintIcon"
        src="../../assets/icons/print.svg"
        (click)="print()"
      />
      <img
        style="cursor: pointer; margin: 0 5% 0 0"
        [matTooltip]="'appointments.gui.tooltips.Settings' | translate"
        height="41em"
        width="41em"
        src="../../assets/icons/gear-white.svg"
        (click)="goToSettings()"
      />
      <img
        *ngIf="ls.premissions?.attendance"
        style="cursor: pointer; margin: 0 5% 0 0"
        [matTooltip]="'attendance.common.attendanceReport' | translate"
        height="41em"
        width="41em"
        src="../../assets/icons/attendance.svg"
        (click)="openAttendanceTracker()"
      />
      <!-- <img
        *ngIf="showCalendar && page == 'Calendar'"
        style="cursor: pointer;  margin:0 5% 0 0"
        matTooltip="select day"
        (click)="picker.open()"
        height="41em"
        width="41em"
        src="../../assets/icons/calendar-white.svg"
      /> -->

      <!-- <input
        class="t-field t-field--date menstural-field invisible-input"
        matInput
        [matDatepicker]="picker"
        #input
        (dateChange)="goToDate($event.value)"
      /> -->
      <mat-datepicker #picker></mat-datepicker>
    </div>
  </div>
</header>

<!-- ========================== header (end) ========================== -->
<div class="content-wrapper" *ngIf="showCalendar && page == 'Calendar'" (mouseleave)="eventHover = false">
  <div style="display: flex;">

  <div class="side-content" [class.collapsed]="collapsed">
    <mat-card class="demo-inline-calendar-card">
      <mat-calendar
        #sideCalendar
        [selected]="sideCalendarDate"
        [dateFilter]="disableHiddenDays"
        (selectedChange)="onMatCalendarDateSelected($event)"
      >
      </mat-calendar>
    </mat-card>
    <mat-divider></mat-divider>
    <ng-container *ngIf="ls.premissions && ls.premissions.countAppointments">
      <div style="overflow-y: scroll; height: 450px; margin-top: 1em">
        <mat-list *ngIf="!isMultiSelect">
          <mat-list-item *ngFor="let resource of getDefaultResources()">
            <mat-icon matListItemIcon>person</mat-icon>
            <span matListItemTitle>{{ appointmentsByRooms ? resource.RoomName : resource.Name }}</span>
            <span matListItemLine>
              {{
                getDefaultAppointmentCounts()[appointmentsByRooms ? resource.AutoIndex : resource.UID] ||
                  0
              }}
              {{ "appointments.gui.labels.appointments" | translate }}
            </span>
          </mat-list-item>
        </mat-list>
        <mat-list *ngIf="isMultiSelect">
          <mat-list-item *ngFor="let resource of getMultiSelectedResources()">
            <mat-icon matListItemIcon>person</mat-icon>
            <span matListItemTitle>{{ appointmentsByRooms ? resource.RoomName : resource.Name }}</span>
            <span matListItemLine>
              {{ getMultiSelectCounts()[appointmentsByRooms ? resource.AutoIndex : resource.UID] || 0 }}
              {{ "appointments.gui.labels.appointments" | translate }}
            </span>
          </mat-list-item>
        </mat-list>
      </div>
    </ng-container>
    <div style="font-size: large; font-weight: 700">{{ yTime }}&#8203;</div>
  </div>
    <button class="toggle-btn" (click)="toggleSidebar()">
      <mat-icon>{{ collapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_left' }}</mat-icon>
    </button>
  </div>
  <div class="main-content">
    <div class="calendar-container">
      <div
        #timeHoverRef
        [innerHTML]="yTime"
        style="
          position: absolute;
          display: none;
          pointer-events: none;
          z-index: 1000;
          font-size: large;
          font-weight: 700;
        "
      ></div>
      <full-calendar #fullcalendar [options]="calendarOptions"></full-calendar>
    </div>
  </div>
</div>

<div class="sub-content" *ngIf="showPat">
  <app-patient-info (pageChange)="onPatientPageChange($event)"></app-patient-info>
  <!-- <app-patient-info (pageChange)="setPage($event, false)"></app-patient-info> -->
</div>

<app-appointment-list
  *ngIf="page == 'List'"
  (pageChange)="goToAppointmentDate($event)"
></app-appointment-list>
<app-leads *ngIf="page == 'Leads'" mode="leads"></app-leads>
<app-appt-stats *ngIf="page == 'Appointments Stats'"> </app-appt-stats>
<app-financial-report *ngIf="page == 'Financial Report'"></app-financial-report>
<div
  *ngIf="eventHover"
  class="custom-tooltip"
  [style.top]="tooltipPosition.top"
  [style.bottom]="tooltipPosition.bottom"
  [style.left]="tooltipPosition.left"
  [style.right]="tooltipPosition.right"
  [style.max-height]="tooltipPosition.maxHeight"
  [innerHTML]="tooltipHtml"
></div>

<!-- ===== PopUps (Start) ===== -->
<app-search-appointments *ngIf="showSearch" (closed)="handleCloseSearchModal($event)">
</app-search-appointments>
<app-pat-documents
  *ngIf="ls.premissions && ls.premissions.uploadDocuments && openDocumentsAdd"
  [showDocuments]="false"
  (closed)="openDocumentsAdd = false"
></app-pat-documents>
<app-appointment
  *ngIf="showAppointment"
  [event]="selectedEventInfo"
  [resourceId]="resourceId"
  [isMultiSelect]="isMultiSelect"
  [slotDuration]="slotDuration"
  (closed)="handleCloseAppointmentModal($event)"
></app-appointment>
<app-patients
  *ngIf="showSelectPatient"
  (closed)="handleClosePatientSearchModal($event)"
  [page]="page"
></app-patients>
<app-patdetails
  *ngIf="showPatDetails"
  (closed)="handleClosePatDetailsModal($event)"
  [page]="page"
></app-patdetails>
<app-block
  *ngIf="showBlock"
  [event]="selectedEventInfo"
  [selectedResourceId]="resourceId"
  [isMultiSelect]="isMultiSelect"
  (closed)="handleCloseBlockModal()"
></app-block>
<app-all-day-event
  *ngIf="showAllDayModal"
  [event]="selectedEventInfo"
  [selectedResourceId]="resourceId"
  [isMultiSelect]="isMultiSelect"
  (closed)="handleCloseAllDayEventModal()"
></app-all-day-event>
<!-- ===== PopUps (End) ===== -->

<app-transfer-appointments
  *ngIf="showTransferAppointments"
  [sourceDate]="transferSourceDate"
  [appointments]="transferSourceAppointments"
  [resourceLabel]="transferResourceLabel"
  [resourceId]="transferResourceId"
  (closed)="closeTransferAppointments()"
  (transferred)="handleAppointmentsTransferred($event)"
></app-transfer-appointments>

<app-commerror></app-commerror>
<app-bottombar></app-bottombar>
